import { Col, Row } from '@helvetia/components/layout'
import Text from '@helvetia/components/Text'
import { css, styled } from '@helvetia/components/theme'
import { VerticalSpaceProps } from '@helvetia/components/theme/css'
import { font } from '@helvetia/components/theme/font'
import { media } from '@helvetia/components/theme/media'
import { Size } from '@helvetia/components/theme/size'
import { rem } from 'polished'

export const TitleWrapper = styled(Col)`
  flex-basis: 0;
  justify-content: flex-end;
  justify-self: flex-end;
  align-content: center;
  ${p =>
    !p.mobile &&
    p.tablet &&
    !p.desktop &&
    css`
      margin-top: ${rem(Size.s)};
    `}
`
export const QuestionWrapper = styled(Text)`
  display: inline-flex;
  flex-flow: column;
  align-content: flex-end;
  justify-content: flex-end;
  width: 100%;
  max-height: ${rem(60)};
  ${media.onlyMobile` ${font.s()}`}
  ${media.tablet` ${font.m()}`}
`

export const ButtonGroup = styled(Row)`
  width: 100%;
  display: inline-flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
`
export const ButtonWrapper = styled(Col)`
  width: 50%;
  flex-grow: 1;
`
